import { create } from 'zustand';

const STORAGE_KEY = 'autoops.assistant.sidebarWidth';
const ASSISTANT_SIDEBAR_DEFAULT_WIDTH = 500;
export const ASSISTANT_SIDEBAR_MIN_WIDTH = 360;
export const ASSISTANT_SIDEBAR_MAX_WIDTH = 800;

const clampWidth = (width: number) =>
  Math.min(
    ASSISTANT_SIDEBAR_MAX_WIDTH,
    Math.max(ASSISTANT_SIDEBAR_MIN_WIDTH, Math.round(width))
  );

const readStoredWidth = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) {
      return ASSISTANT_SIDEBAR_DEFAULT_WIDTH;
    }
    const parsed = Number(raw);
    return Number.isFinite(parsed)
      ? clampWidth(parsed)
      : ASSISTANT_SIDEBAR_DEFAULT_WIDTH;
  } catch {
    return ASSISTANT_SIDEBAR_DEFAULT_WIDTH;
  }
};

type AssistantPanelState = {
  isOpen: boolean;
  sidebarWidth: number;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setSidebarWidth: (width: number) => void;
};

export const useAssistantPanelStore = create<AssistantPanelState>(
  (set, get) => ({
    isOpen: false,
    sidebarWidth: readStoredWidth(),
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set({ isOpen: !get().isOpen }),
    setSidebarWidth: (width) => {
      const sidebarWidth = clampWidth(width);
      try {
        localStorage.setItem(STORAGE_KEY, String(sidebarWidth));
      } catch {
        // Ignore quota / private-mode failures; width still updates in memory.
      }
      set({ sidebarWidth });
    },
  })
);
